import { render } from "./DsSkeleton.vue?vue&type=template&id=41904396&scoped=true"
import script from "./DsSkeleton.vue?vue&type=script&lang=js"
export * from "./DsSkeleton.vue?vue&type=script&lang=js"

import "./DsSkeleton.vue?vue&type=style&index=0&id=41904396&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41904396"]])

export default __exports__